module.exports = __webpack_public_path__ + "img/29.081c6b78.jpg";